module.exports = __webpack_public_path__ + "img/undraw_fitting_piece_re_pxay 1.3c7a704b.svg";